import { Concept, ConceptActivation } from "@fusion-advantage/formlib"
import { L1ReasonableButton } from "../l1/L1Button"
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import L6FormContext from "../l6/L6FormContext"
import { useCallback, useContext } from "react"

interface L3JumpButtonProps {
	activation: ConceptActivation|null
	jumpConcept: Concept
	direction: 'left'|'right'
	title: string
}

const L3JumpButton = ({activation, jumpConcept, direction, title}: L3JumpButtonProps) => {
	const { jumpToConcept } = useContext(L6FormContext)
	const handleClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault()
		// console.debug(err.concept.xpaths)
		jumpToConcept(jumpConcept)
	}, [jumpToConcept, jumpConcept])
	if(activation === ConceptActivation.Hidden) {
		return <div />
	}
	return (
		<L1ReasonableButton
			disabled={activation === ConceptActivation.Disabled}
			icon={direction == "left" ? faArrowLeft : faArrowRight}
			label={title}
			onClick={handleClick}
		/>
	)
}

export default L3JumpButton
